module.exports = __webpack_public_path__ + "static/atrium-bg-c74d427b6019bb0f7b91da2d417db69c.jpg";